import { render, staticRenderFns } from "./FreightBillDmdRadio.vue?vue&type=template&id=64129496"
import script from "./FreightBillDmdRadio.vue?vue&type=script&lang=js"
export * from "./FreightBillDmdRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64129496')) {
      api.createRecord('64129496', component.options)
    } else {
      api.reload('64129496', component.options)
    }
    module.hot.accept("./FreightBillDmdRadio.vue?vue&type=template&id=64129496", function () {
      api.rerender('64129496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillDmdRadio.vue"
export default component.exports